import { chartTheme } from './chartHelper';
import Line from './shapes/Line';

export default function VerticalGridLine({
    x,
    height,
    color,
    isAnimated,
}: {
    x: number;
    height: number;
    color?: string;
    isAnimated?: boolean;
}) {
    return (
        <g>
            <Line
                from={{ x, y: 0 }}
                to={{
                    x,
                    y: height,
                }}
                stroke={color ?? chartTheme.colors.gridline}
                strokeWidth={1}
                pointerEvents="none"
                isAnimated={isAnimated}
            />
        </g>
    );
}
